import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute - Wraps routes that require authentication.
 * Redirects to root (welcome page) if user is not logged in.
 * If adminOnly is true, also checks that user.role === 'admin'.
 */
export function ProtectedRoute({ user, children, adminOnly = false }) {
  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (adminOnly && user.role !== 'admin') {
    return <Navigate to="/home" replace />;
  }

  return children;
}

ProtectedRoute.propTypes = {
  user: PropTypes.shape({
    role: PropTypes.string,
  }),
  children: PropTypes.node.isRequired,
  adminOnly: PropTypes.bool,
};
